import { render, staticRenderFns } from "./ResultDetailSacrificeOutRight.vue?vue&type=template&id=b18cb136&scoped=true&"
import script from "./ResultDetailSacrificeOutRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailSacrificeOutRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18cb136",
  null
  
)

export default component.exports